!function (angular) {
   "use strict";

    var service = angular.module('service.MetaData', []);

    service.factory('metaDataService', ['$http', 'halClient', 'appSettings', function ($http, halClient, appSettings) {

        var metaDataUrl = appSettings.apiBaseUri + "/app/metadata";

        return {
            getMetaData: function () {
                return halClient.$get(metaDataUrl);
            }
        };

    }]);
}(angular)